module.exports = __webpack_public_path__ + "static/media/link.6b789158.png";